import { useGetDisruptionTypes } from '@/pages/Disruptions/api/useGetDisruptionTypes'
import { DisruptionFormValues } from '@/pages/Disruptions/types'
import { SuggestionInputTable } from '@/ui/SuggestionInputTable'
import { UseFormReturn } from 'react-hook-form'
import styles from './DisruptionTypeInput.module.scss'

export const DisruptionTypeInput = ({ form }: { form: UseFormReturn<DisruptionFormValues> }) => {
    const { data: disruptionTypes } = useGetDisruptionTypes()

    return (
        <SuggestionInputTable
            options={
                disruptionTypes?.map((type) => ({
                    id: type.code,
                    value: type.description,
                    label: type.description,
                })) || []
            }
            variant="table"
            type="text"
            transparent
            fullWidth
            className={styles.disruptionTypeInput}
            placeholder="Disruption type"
            value={form.watch('disruptionType')}
            onChange={(value) => form.setValue('disruptionType', value, { shouldDirty: true })}
        />
    )
}
